export const RACE = {
    asian: {
        en: 'Asian',
        es: 'Asiática'
    },
    black: {
        en: 'Black or African American',
        es: 'Raza negra o afroamericana'
    },
    hisp: {
        en: 'Hispanic or Latino',
        es: 'Hispano o latino'
    },
    indi: {
        en: 'Indigenous, American Indian, or Alaskan Native',
        es: 'Indígena, indígena americano o nativo de Alaska'
    },
    hawa: {
        en: 'Native Hawaiian or Other Pacific Islander',
        es: 'Nativo de Hawái u otra isla del Pacífico'
    },
    white: {
        en: 'White or Caucasian',
        es: 'Raza blanca o caucásico'
    },
    other: {
        en: 'Other',
        es: 'Otro'
    },
    dna: {
        en: 'Prefer Not to Answer',
        es: 'Prefiero no responder'
    },
    idk: {
        en: 'Don’t Know',
        es: 'No sé'
    }
} as Record<string, { en: string; es: string }>;
